import React from 'react';
import { Container } from 'components/UI';
import { Icon, Title } from '@landing/ui';
import LocationMap from './LocationMap/LocationMap';
import { getMeetupDateString } from 'utils';

import * as styles from './Location.module.scss';

export default function Location({
  title,
  address,
  meetupStartTime,
  timeZone,
  meetupDate,
  initialCoordinates,
  markerSettings,
}) {
  const date = getMeetupDateString(meetupDate, {
    day: '2-digit',
    month: 'long',
    weekday: 'long',
  });
  const dateAndTime = `${date}, ${meetupStartTime} ${timeZone}`;

  return (
    <Container id="address" background="transparent">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <section className={styles.info}>
          <div className={styles.infoItem}>
            <Icon name="clock" className={styles.infoIcon} />
            <span className={styles.infoDescription}>{dateAndTime}</span>
          </div>
          <div className={styles.infoItem}>
            <Icon name="marker" className={styles.infoIcon} />
            <span className={styles.infoDescription}>{address}</span>
          </div>
        </section>
        <LocationMap
          className={styles.mapSection}
          initialCoordinates={initialCoordinates}
          markerSettings={markerSettings}
        />
      </div>
    </Container>
  );
}
